import React from 'react';
import { Helmet } from 'react-helmet';

const Head = () => (
  <Helmet>
    <script>
      {`
			  	dataLayer = [{
					"page": "CustomarQ Web App",
					"country": "US",
					"language": "EN",
					"section1": "CustomarQ Web App",
					"section2": "CustomarQ Web App"
				}]
			`}
    </script>
    <meta charset="utf-8" />
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, shrink-to-fit=no, viewport-fit=cover, user-scalable=no"
    />
    <link rel="manifest" href="/manifest.json" />
    <link rel="canonical" href="https://appetiteapp.chubb.com" />
    <meta name="theme-color" content="#1F1A55" />
    <meta
      name="description"
      content="Harness the power of Chubb Mid-Market Commercial Insurance through our new appetite and resource web app."
    />
    <meta
      name="keywords"
      content="chubb, commercial insurance, chubb insurance, chubb appetite, insurance appetite, mid-market commerical insurance, chubb web app, "
    />
    <meta name="robots" content="index, follow" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-status-bar-style" content="black" />
    {
      // iPhone SE
    }
    <link
      rel="apple-touch-startup-image"
      href="/img/touch/launch-640x1136.png"
      media="(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
    />
    <link
      rel="apple-touch-startup-image"
      href="/img/touch/launch-640x1136.png"
      media="(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
    />

    {
      // iPhone 6/7/8
    }
    <link
      rel="apple-touch-startup-image"
      href="/img/touch/launch-750x1294.png"
      media="(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
    />
    <link
      rel="apple-touch-startup-image"
      href="/img/touch/launch-750x1294.png"
      media="(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
    />

    {
      // iPhone 6+/7+/8+
    }
    <link
      rel="apple-touch-startup-image"
      href="/img/touch/launch-1242x2148.png"
      media="(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
    />
    <link
      rel="apple-touch-startup-image"
      href="/img/touch/launch-1242x2148.png"
      media="(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"
    />

    {
      // iPhone X
    }
    <link
      rel="apple-touch-startup-image"
      href="/img/touch/launch-1125x2436.png"
      media="(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
    />
    <link
      rel="apple-touch-startup-image"
      href="/img/touch/launch-1125x2436.png"
      media="(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"
    />

    {
      // iPad 3/4/Pro 9.7"
    }
    <link
      rel="apple-touch-startup-image"
      href="/img/touch/launch-1536x2048.png"
      media="(min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)"
    />
    <link
      rel="apple-touch-startup-image"
      href="/img/touch/launch-1536x2048.png"
      media="(min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape)"
    />

    {
      // iPad Pro 10.5"
    }
    <link
      rel="apple-touch-startup-image"
      href="/img/touch/launch-1668x2224.png"
      media="(min-device-width: 834px) and (max-device-width: 834px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)"
    />
    <link
      rel="apple-touch-startup-image"
      href="/img/touch/launch-1668x2224.png"
      media="(min-device-width: 834px) and (max-device-width: 834px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape)"
    />

    {
      // iPad Pro 12.9"
    }
    <link
      rel="apple-touch-startup-image"
      href="/img/touch/launch-2048x2732.png"
      media="(min-device-width: 1024px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)"
    />
    <link
      rel="apple-touch-startup-image"
      href="/img/touch/launch-2048x2732.png"
      media="(min-device-width: 1024px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape)"
    />

    <link href="/favicon.ico" rel="shortcut icon" />
    <link rel="apple-touch-icon" sizes="180x180" href="/img/touch/apple-touch-icon.png" />
    <meta name="msapplication-TileColor" content="#1F1A55" />
    <meta name="msapplication-TileImage" content="/img/touch/mstile-150x150.png" />
    <meta name="application-name" content="Chubb CI" />
    <meta name="msapplication-starturl" content="/?utm_source=mstile" />
    <meta name="msapplication-tooltip" content="Chubb Commercial Insurance Mid-Market Web App" />
    <meta name="msapplication-config" content="/ieconfig.xml" />

    <meta property="og:title" content="Commercial Insurance Mid-Market Web App" />
    <meta property="og:site_name" content="Commercial Insurance Mid-Market Web App" />
    <meta property="og:url" content="https://appetiteapp.chubb.com" />
    <meta
      property="og:description"
      content="Harness the power of Chubb Mid-Market Commercial Insurance through our new appetite and resource web app."
    />
    <meta property="og:image" content="https://appetiteapp.chubb.com/img/og-icon.png" />
    <meta property="og:type" content="website" />

    <meta name="twitter:title" content="Commercial Insurance Mid-Market Web App" />
    <meta name="twitter:url" content="https://appetiteapp.chubb.com" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta
      name="twitter:description"
      content="Harness the power of Chubb Mid-Market Commercial Insurance through our new appetite and resource web app."
    />
    <meta name="twitter:image" content="https://appetiteapp.chubb.com/img/og-icon.png" />
    <meta name="twitter:image:alt" content="Chubb Appetite" />
    <meta name="twitter:site" content="@ChubbNA" />

    <title>Commercial Insurance Mid-Market Web App</title>

    <script>
      {navigator.userAgent === 'ReactSnap'
        ? ``
        : `
					setTimeout(function() {
						(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
						new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
						j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
						'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
						})(window,document,'script','dataLayer','GTM-WKFVJGR')
					}, 0);
				`}
    </script>
    <script>
      {`
			if(Function('/*@cc_on return document.documentMode===10@*/')()){
				document.documentElement.className+=' ie10';
			}
		`}
    </script>
  </Helmet>
);

export default Head;



// WEBPACK FOOTER //
// ./src/components/Head.js